<template>
    <ItemGroupSelect
        @update-selected-group="updateSelectedGroup"
        :activeGroup="activeGroup"
        :groups="groups"
        :className="'my-registrations'"
    ></ItemGroupSelect>

    
    <h1 class="my-page__title">{{ user.name }}s aktivitet</h1>
    
    <div class="my-page__year-select-wrapper">
        <Select
            v-model="selectedYear"
            :options="availableYears"
            style="width: 100%"
        />
    </div>

    <Bargraph
        :userRegistrations="userRegistrations"
        :activeGroup="activeGroup"
        :selectedYear="selectedYear"
    ></Bargraph>

    <GroupToplist
        :items="groupToplistItems"
        :groups="groupToplistGroups"
        :groupName="groupName"
    ></GroupToplist>

    <div class="toplist__container">
        <div class="toplist__form-column">
            <Registerform
                ref="registerform"
                @create="createRegistration"
                :municipalities="municipalities"
                :user="user"

                :activeItems="activeItems"
                :groupName="groupName"
            ></Registerform>
        </div>

        <ToplistUsersMypage
            :toplist="toplist"
            :user="user"
            :groupName="groupName"
            :activeGroup="activeGroup"
            :getUserAmount="getUserAmountYear"
            :season="selectedYear"
            :unit="unit"
        ></ToplistUsersMypage>
    </div>

    <Activitytable
        :registrations="activeRegistrations"
        :groupName="groupName"
        :getUserAmount="getUserAmountTotal"
        :getAmountClass="getAmountClass"
        :selectedYear="selectedYear"
        @delete="(id) => deleteRegistration(id)"
    ></Activitytable>


    <div class="my-page__profile-section">
        <h2 class="toplist__title toplist__title--bottom">
            <i class="pi pi-user"></i>
            Min profil
        </h2>
        <a class="toplist__link" href="/endre-bruker">Rediger profildetaljer</a>
    </div>
            
</template>
<script>
    import ToplistUsersMypage from './components/ToplistUsersMypage';
    import Bargraph      from './components/Bargraph';
    import ItemGroupSelect   from './components/ItemGroupSelect';
    import Registerform  from './components/Registerform';
    import Activitytable from './components/Activitytable';
    import GroupToplist  from './components/GroupToplist';
    import Select        from 'primevue/select';

    export default {
        components: {
            ToplistUsersMypage,
            Bargraph,
            ItemGroupSelect,
            Registerform,
            Activitytable,
            GroupToplist,
            Select,
        },


        props : [
            'season'
        ],

        data() {
            return {
                toplistUrl       : '/fetch/registrations/toplist',
                groupsToplistUrl : '/fetch/user/groups/toplist',
                groupsUrl        : '/fetch/itemgroups',
                itemsUrl         : '/fetch/items',
                municipalitiesUrl: '/fetch/municipalities',
                userUrl          : '/fetch/user',
                user             : {name: '', id: null},
                groups           : [],
                items            : [],
                userRegistrations: [],
                toplist          : [],
                toplistData      : [],
                groupToplistItems : [],
                groupToplistGroups: [],
                municipalities   : [],
                activeGroup      : 1,
                selectedYear     : Number(this.season),
            }
        },
        created() {
            const params = new Proxy(new URLSearchParams(window.location.search), {
                get: (searchParams, prop) => searchParams.get(prop)
            });

            this.fetchUser();
            // The group from ?itemGroup= (e.g. the frontpage shortcuts) can only be selected once the groups are loaded
            this.fetchGroups(params.itemGroup ? Number(params.itemGroup) : null);
            this.fetchItems();
            this.fetchMunicipalities();
            this.fetchGroupsToplist();
            this.registerWebMcpTools();
        },
        methods: {
            registerWebMcpTools() {
                if (typeof document === 'undefined' || !document.modelContext) {
                    return;
                }

                Promise.resolve(document.modelContext.registerTool({
                    name: 'registerPicking',
                    description: 'Register a new picking entry (kommune, type, and amount) on the currently selected activity tab.',
                    inputSchema: {
                        type: 'object',
                        properties: {
                            location: {
                                type: 'string',
                                description: 'Name of the municipality (kommune) where the picking took place, e.g. "Oslo".',
                            },
                            item: {
                                type: 'string',
                                description: 'Name of the type picked, matching one of the currently active options shown on the page.',
                            },
                            amount: {
                                type: 'number',
                                description: 'Amount picked, in the unit shown on the page (kg or liter, depending on type).',
                            },
                            date: {
                                type: 'string',
                                description: 'Date the picking took place (YYYY-MM-DD). Optional, defaults to today.',
                            },
                        },
                        required: ['location', 'item', 'amount'],
                    },
                    execute: async ({ location, item, amount, date }) => {
                        const municipality = this.municipalities.find(m => m.name.toLowerCase() === String(location).toLowerCase());
                        if (!municipality) {
                            return `Fant ingen kommune som heter "${location}".`;
                        }

                        const activeItems = this.getActiveItems();
                        const matchedItem = activeItems.find(i => i.name.toLowerCase() === String(item).toLowerCase());
                        if (!matchedItem) {
                            return `Fant ikke "${item}" blant gjeldende typer: ${activeItems.map(i => i.name).join(', ')}.`;
                        }

                        const formData = new FormData();
                        formData.set('date', date || new Date().toISOString().slice(0, 10));
                        formData.set('location', municipality.id);
                        formData.set('item_id', matchedItem.id);
                        formData.set('amount', amount);

                        const result = await this.createRegistration(formData);

                        return result
                            ? `Registrerte ${amount} av ${matchedItem.name} i ${municipality.name}.`
                            : 'Klarte ikke å registrere.';
                    },
                })).catch(error => console.error('WebMCP tool registration failed', error));

                Promise.resolve(document.modelContext.registerTool({
                    name: 'deletePicking',
                    description: 'Delete a previously registered picking entry on the currently selected activity tab.',
                    inputSchema: {
                        type: 'object',
                        properties: {
                            item: {
                                type: 'string',
                                description: 'Name of the type picked for the entry to delete, matching one of the currently active options shown on the page.',
                            },
                            date: {
                                type: 'string',
                                description: 'Date of the picking to delete (YYYY-MM-DD).',
                            },
                            amount: {
                                type: 'number',
                                description: 'Amount of the entry to delete. Optional, only needed to tell apart multiple entries with the same type and date.',
                            },
                        },
                        required: ['item', 'date'],
                    },
                    execute: async ({ item, date, amount }) => {
                        const candidates = (this.activeRegistrations ?? []).filter(reg => {
                            const matchesItem = reg.type_name.toLowerCase() === String(item).toLowerCase();
                            const matchesDate = String(reg.date).slice(0, 10) === date;
                            const matchesAmount = amount === undefined || amount === null || Number(reg.amount) === Number(amount);

                            return matchesItem && matchesDate && matchesAmount;
                        });

                        if (candidates.length === 0) {
                            return `Fant ingen registrering av "${item}" den ${date}.`;
                        }

                        if (candidates.length > 1) {
                            const details = candidates.map(r => `${r.amount} ${r.uom.name}`).join(', ');
                            return `Fant flere registreringer som matcher: ${details}. Oppgi mengde for å velge riktig.`;
                        }

                        const [match] = candidates;
                        const result = await this.deleteRegistration(match.id);

                        return result
                            ? `Slettet registrering av ${match.amount} ${match.uom.name} ${item} den ${date}.`
                            : 'Klarte ikke å slette registreringen.';
                    },
                })).catch(error => console.error('WebMCP tool registration failed', error));
            },
            fetchUser() {
                this._get(this.userUrl).then(data => {
                    this.user = data;
                    this.fetchLocationToplist();
                    this.fetchUserRegistrations();
                });
            },
            fetchUserRegistrations() {
                this._get(`${this.userUrl}/registrations?year=${this.selectedYear}`).then(data => {
                    this.userRegistrations = data;
                });
            },
            fetchLocationToplist() {
                this._get(`${this.toplistUrl}?location=${this.user.location}&year=${this.selectedYear}`).then(data => {
                    this.toplistData = data;
                    this.toplist     = data[this.activeGroup];
                });
            },
            fetchGroupsToplist() {
                this._get(`${this.groupsToplistUrl}?group=${this.activeGroup}&year=${this.selectedYear}`).then(data => {
                    this.groupToplistItems  = data.items;
                    this.groupToplistGroups = data.groups;
                });
            },
            fetchGroups(requestedGroupId = null) {
                this._get(this.groupsUrl).then(data => {
                    this.groups = data;

                    if (requestedGroupId) {
                        this.updateSelectedGroup(requestedGroupId);
                    }
                });
            },
            fetchItems() {
                this._get(this.itemsUrl).then(data => {
                    this.items = data;
                });
            },
            fetchMunicipalities() {
                this._get(this.municipalitiesUrl).then(data => {
                    this.municipalities = data;
                });
            },
            async _get(url) {
                try {
                    const response = await fetch(url);

                    return await response.json();
                } catch(error) {
                    return console.error(error);
                }
            },
            async _post(url, body) {
                try {
                    const response = await fetch(url, {
                        method : "POST", 
                        body   : body,
                        headers: {
                            Accept: 'application/json'
                        },
                    });

                    return await response.json();
                } catch(error) {
                    return console.error(error);
                }
            },
            updateSelectedGroup(groupId){
                const group = this.groups.find(group => Number(group.id) === Number(groupId));

                if (group && group.status.id) {
                    this.activeGroup = Number(groupId);
                }
            },
            getActiveGroup() {
                return this.groups.filter(group => {
                    return Number(group.id) === Number(this.activeGroup);
                });
            },
            getActiveItems() {
                return this.items.filter(item => {
                    return Number(item.group_id) === Number(this.activeGroup);
                });
            },
            filteredRegistrations() {
                return this.userRegistrations.filter(i => {
                    return Number(i.id) === Number(this.activeGroup);
                });
            },
            sumRegistrations(group) {
                return group.registrations.reduce((total, reg) => total + reg.amount, 0)
            },
            sumRegistrationsYear(group,year) {
                let total = 0;
                group.registrations.forEach(reg => {
                    const regDate = new Date(reg.date)
                    if(regDate.getFullYear() == year){
                        total += reg.amount;
                    }
                });
                return total;
            },
            createRegistration(data) {
                const now = new Date(Date.now());
                const d   = new Date(data.get('date'));
                d.setHours(now.getHours(), now.getMinutes(), now.getSeconds());

                const seconds  = this.prefix(d.getSeconds());
                const minutes  = this.prefix(d.getMinutes());
                const hours    = this.prefix(d.getHours());
                const day      = this.prefix(d.getDate());
                const month    = this.prefix(d.getMonth() + 1);

                const formattedDate = `${d.getFullYear()}-${month}-${day} ${hours}:${minutes}:${seconds}`;
                data.set('date', formattedDate);

                return this._post(`/fetch/registrations`, data).then(data => {
                    this.fetchUserRegistrations();
                    this.fetchLocationToplist();
                    this.fetchGroupsToplist();
                    this.$refs.registerform?.resetForm();

                    return data;
                });
            },
            prefix(number) {
                return number < 10 ? `0${number}` : number;
            },
            deleteRegistration(id) {
                return this._post(`/fetch/registrations/${id}/delete`, []).then(data => {
                    this.fetchUserRegistrations();
                    this.fetchLocationToplist();

                    return data;
                });
            },
            // Keeps the amount a number (the child components' props expect one), unlike toFixed() which returns a string
            roundToOneDecimal: function(num) {
                return Math.round(num * 10) / 10;
            },
        },
        computed: {
            filteredToplist: function() {
                return this.toplist;
            },
            availableYears: function() {
                const years = [];
                for (let y = Number(this.season); y >= 2016; y--) {
                    years.push(y);
                }
                return years;
            },
            activeItems: function() {
                return this.getActiveItems().sort((a, b) => a.name.localeCompare(b.name, 'no'));
            },
            groupName: function() {
                const activeGroup = this.getActiveGroup();

                return activeGroup.length ? activeGroup[0].name : '';
            },
            unit: function() {
                return this.activeItems.length ? this.activeItems[0].uom.name : '';
            },
            activeRegistrations: function() {
                const active = this.filteredRegistrations();
                if(active){
                    return  active[0]?.registrations.sort((a, b) => new Date(b.date) - new Date(a.date));
                }
            },
            getUserAmountTotal: function() {
                const active = this.filteredRegistrations();
                const amount = active.length > 0 ? this.sumRegistrations(active[0]) : 0;
                return this.roundToOneDecimal(amount);
            },
            getUserAmountYear: function() {
                const active = this.filteredRegistrations();
                const amount = active.length > 0 ? this.sumRegistrationsYear(active[0], this.selectedYear) : 0;
                return this.roundToOneDecimal(amount);
            },
            getAmountClass: function() {
                const active = this.filteredRegistrations();

                return active.length > 0 && this.sumRegistrations(active[0]).toString().length > 3 ? 'activity__amount--decreased-font-size' : '';
            },
        },
        watch: {
            activeGroup: function() {
                this.toplist = this.toplistData ? this.toplistData[this.activeGroup] : [];
                this.fetchGroupsToplist();
            },
            selectedYear: function() {
                this.fetchUserRegistrations();
                this.fetchLocationToplist();
                this.fetchGroupsToplist();
            }
        }
    };
</script>